var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-dialog',{ref:"serviceUnavailableDialog",attrs:{"persistent":"","content-class":"service-unavailable-dialog-outer-wrapper"}},[_c('q-card',{staticClass:"service-unavailable-dialog-wrapper"},[_c('q-card-section',[_c('service-unavailable-content',{attrs:{"is-maintenance":_vm.isMaintenance},on:{"available":_vm.onAvailable}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }